import React from "react";

export const PhoneIcon: React.FC<{
    color?: string;
    width?: string;
    height?: string;
}> = ({ color = "black", width = "40px", height = "20px" }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 65.178 65.178"
        style={{ width, height }}
        fill={color}
    >
        <g
            id="Groupe_34387"
            data-name="Groupe 34387"
            transform="translate(0 0)"
        >
            <path
                id="Tracé_19960"
                data-name="Tracé 19960"
                d="M63.874,48.705a4.351,4.351,0,0,0-.785-.622L50.542,38.336a4.387,4.387,0,0,0-5.807-.385L41.21,41.477a2.962,2.962,0,0,1-4.622-.267V41.3A56.586,56.586,0,0,1,23.953,28.708h.1a2.963,2.963,0,0,1-.356-4.814l3.481-3.451a4.355,4.355,0,0,0,.963-2.666,4.444,4.444,0,0,0-1.3-3.14L17.095,2.089a4.537,4.537,0,0,0-.607-.785A4.444,4.444,0,0,0,13.332,0C7.407,0,0,6.962,0,15.554A15.481,15.481,0,0,0,1.482,22.22,94.093,94.093,0,0,0,42.958,63.7a15.478,15.478,0,0,0,6.636,1.481c8.621,0,15.583-7.407,15.583-13.332A4.444,4.444,0,0,0,63.874,48.705Zm-1.659,3.437c-.237,4.059-5.57,10.073-12.591,10.073A12.486,12.486,0,0,1,44.247,61a2.791,2.791,0,0,0-.489-.178A90.863,90.863,0,0,1,4.37,21.434a2.957,2.957,0,0,0-.193-.5,12.486,12.486,0,0,1-1.215-5.377c0-7.184,6.3-12.591,10.369-12.591a1.481,1.481,0,0,1,1.052.43,1.637,1.637,0,0,1,.207.267l.163.237,9.762,12.547.237.281a1.482,1.482,0,0,1,.43,1.052,1.378,1.378,0,0,1-.207.741l-3.3,3.274a5.925,5.925,0,0,0-.274,8.375l.023.024.119.178A59.442,59.442,0,0,0,34.87,43.61l.119.089a5.925,5.925,0,0,0,8.251,0l.163-.163,3.318-3.348A1.377,1.377,0,0,1,47.4,40a1.481,1.481,0,0,1,1.052.43l.281.252,12.5,9.688.252.178a1.419,1.419,0,0,1,.726,1.3A2.874,2.874,0,0,0,62.215,52.142Z"
            />
        </g>
    </svg>
);
